window.addEventListener('propel-page-scrolled', () => {
	if (document.body.classList.contains('forms-loaded')) {
		return;
	}

	document.body.classList.add('forms-loaded');

	const firstHubspotScript = document.querySelector('[data-hubspot-src]');
	const hubspotInitScripts = document.querySelectorAll('.hubspot-init');

	if (!firstHubspotScript || hubspotInitScripts.length === 0) {
		return;
	}

	const script = document.createElement('script');
	script.src = firstHubspotScript.dataset.hubspotSrc;
	script.type = 'text/javascript';

	script.onload = () => {
		hubspotInitScripts.forEach((initScript) => {
			const newScript = document.createElement('script');
			newScript.type = 'text/javascript';
			newScript.textContent = initScript.textContent;
			initScript.parentElement.appendChild(newScript);
		});
	};

	document.body.appendChild(script);
});
